const invoiceStatusEnum = [
    {
        name: "Alle",
        value: 0
    },
    {
        name: "UNPAID",
        value: 1,
        color: 'error'
    },
    {
        name: "PARTIALLY_PAID",
        value: 2,
        color: 'primary'
    },
    {
        name: "PAID",
        value: 3,
        color: 'green',
    },
    {
        name: "OVERPAID",
        value: 4,
        color: 'fontDefault'
    },
];

export default invoiceStatusEnum;